import React from 'react';
import PropTypes from 'prop-types';
import { LabelValue, Tooltip } from 'orion';
export var AttributeValue = function AttributeValue(_ref) {
  var details = _ref.details;

  if (!details) {
    return null;
  }

  var _ref2 = details || {},
      url = _ref2.url,
      value = _ref2.value;

  return url ? /*#__PURE__*/React.createElement(Tooltip, {
    text: value,
    overflowOnly: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "oui-ellipsis"
  }, /*#__PURE__*/React.createElement("a", {
    href: url,
    rel: "noopener noreferrer"
  }, value))) : /*#__PURE__*/React.createElement(Tooltip, {
    text: value,
    overflowOnly: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "oui-ellipsis"
  }, value));
};
export var cellRendererWithToolTip = function cellRendererWithToolTip(_ref3) {
  var cellData = _ref3.cellData;
  return /*#__PURE__*/React.createElement(Tooltip, {
    text: cellData,
    overflowOnly: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "oui-ellipsis"
  }, cellData));
};

var DetailsItem = function DetailsItem(_ref4) {
  var details = _ref4.details;

  if (!details) {
    return null;
  }

  var title = details.title,
      url = details.url,
      value = details.value;

  if (!url && value) {
    return /*#__PURE__*/React.createElement(LabelValue, {
      label: title,
      value: value,
      truncateValue: true
    });
  }

  return /*#__PURE__*/React.createElement(LabelValue, {
    label: title,
    renderValue: function renderValue() {
      return /*#__PURE__*/React.createElement(AttributeValue, {
        details: details
      });
    }
  });
};

AttributeValue.propTypes = {
  details: PropTypes.object.isRequired
};
DetailsItem.propTypes = {
  details: PropTypes.object
};
export default DetailsItem;